var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14449 18.7453C1.67569 18.7453 1.26548 18.5695 0.913879 18.2179C0.562276 17.8663 0.386475 17.4561 0.386475 16.9873V1.75118C0.386475 1.28238 0.562276 0.872172 0.913879 0.520569C1.26548 0.168965 1.67569 -0.00683594 2.14449 -0.00683594H17.3806C17.8494 -0.00683594 18.2596 0.168965 18.6112 0.520569C18.9628 0.872172 19.1386 1.28238 19.1386 1.75118V8.05074L23.8267 3.36269V15.3758L19.1386 10.6878V16.9873C19.1386 17.4561 18.9628 17.8663 18.6112 18.2179C18.2596 18.5695 17.8494 18.7453 17.3806 18.7453H2.14449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.9054d12329cb00c49b44fed727af2f37.svg";
export { ForwardRef as ReactComponent };